import PropTypes from 'prop-types';
import { useRef, useState, useEffect, useCallback } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
//
import KanbanInputName from './kanban-input-name';
import { KanbanCardCreateModal } from './kanban-card-create-modal';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { enqueueSnackbar } from 'notistack';

// ----------------------------------------------------------------------

export default function KanbanColumnToolBar({
  columnName,
  onDeleteColumn,
  onClearColumn,
  onUpdateColumn,
  reload,
  columnId
}) {
  const renameRef = useRef(null);
  const add = useBoolean();

  const popover = usePopover();

  const confirmDialog = useBoolean();
  const [ selectedItem, setSelectedItem ] = useState({})

  const [ name, setName ] = useState(columnName);

  useEffect(() => {
    if (popover.open) {
      if (renameRef.current) {
        renameRef.current.focus();
      }
    }
  }, [ popover.open ]);

  const handleChangeName = useCallback((event) => {
    setName(event.target.value);
  }, []);
  const handleKeyUpUpdateColumn = useCallback(
    async (event) => {
      if (event.key === 'Enter') {
        if (!name) return;

        const formData = new FormData();
        formData.append('title', name);
        formData.append('_method', 'PUT');

        try {
          const response = await postRequest(
            `${endpoints.admin_dashboard.marketing_management.board.crud_stage}/${columnId}`, // pass columnId as prop
            formData,
            true
          );

          if (response?.metadata?.success) {
            enqueueSnackbar(response?.metadata?.message, { variant: 'success' });
            reload();
          } else {
            console.log(response?.metadata?.message);
          }
        } catch (error) {
          // enqueueSnackbar('Error while updating stage', { variant: 'error' });
          console.error(error);
        }
      }
    },
    [ name, columnId, reload, enqueueSnackbar ]
  );

  const handleclose = () => {
    add.onFalse();
    setSelectedItem({})
  }

  return (
    <>
      <Stack
        spacing={ 1 }
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={ { pt: 3 } }
      >
        <KanbanInputName
          inputRef={ renameRef }
          placeholder="Section name"
          value={ name }
          onChange={ handleChangeName }
          onKeyUp={ handleKeyUpUpdateColumn }
        />

        <IconButton color={ popover.open ? 'inherit' : 'default' } onClick={ popover.onOpen }>
          <Iconify icon="eva:more-horizontal-fill" />
        </IconButton>
      </Stack>

      <CustomPopover
        open={ popover.open }
        onClose={ popover.onClose }
        sx={ {
          ml: 1.5,
          width: 160,
        } }
      >
        {/* <MenuItem onClick={ popover.onClose }>
          <Iconify icon="solar:pen-bold" />
          Rename
        </MenuItem> */}

        {/* <MenuItem
          onClick={ () => {
            // onClearColumn();
            add.onTrue();
          } }
        >
          <Iconify icon="material-symbols:create-new-folder-rounded" />
          Create  Card
        </MenuItem> */}
        {/* <MenuItem
          onClick={ () => {
            onClearColumn();
            popover.onClose();
          } }
        >
          <Iconify icon="solar:eraser-bold" />
          Clear
        </MenuItem> */}

        <MenuItem
          onClick={ () => {
            confirmDialog.onTrue();
            popover.onClose();
          } }
          sx={ { color: 'error.main' } }
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
      </CustomPopover>


      <KanbanCardCreateModal
        open={ add.value }
        onClose={ handleclose }
      // reload={ () => getCostCodes() }
      // currentItem={ selectedItem }

      />

      <ConfirmDialog
        open={ confirmDialog.value }
        onClose={ confirmDialog.onFalse }
        title="Delete"
        content={
          <>
            Are you sure want to delete column?
            <Box sx={ { typography: 'caption', color: 'error.main', mt: 2 } }>
              <strong> NOTE: </strong> All tasks related to this category will also be deleted.
            </Box>
          </>
        }
        action={
          <Button
            variant="contained"
            onClick={ () => {
              onDeleteColumn();
              confirmDialog.onFalse();
            } }
          >
            Delete
          </Button>
        }
      />
    </>
  );
}

KanbanColumnToolBar.propTypes = {
  columnName: PropTypes.string,
  onClearColumn: PropTypes.func,
  onDeleteColumn: PropTypes.func,
  onUpdateColumn: PropTypes.func,
};
